module.exports = __webpack_public_path__ + "img/Recurso 36@300x.56535d73.webp";